import { BuyTagModelType } from '@teinor/erp/types/company/order/buy/buyTag'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'
export interface BuyTagsAction {
    type: 'CHANGE_BUY_TAGS'
    payload: BuyTagsPayload
}
export type BuyTagsPayload = BuyTagModelType[]
export type BuyTagJson = { [id: number]: BuyTagModelType } | null
export default function buyTags(state: BuyTagJson = null, action: BuyTagsAction): BuyTagJson {
    switch (action.type) {
        case 'CHANGE_BUY_TAGS':
            return state = dictionaryComplexFromJsonArr(action.payload)
        default:
            return state
    }
}